import { Action, ActionReducer, createFeature, createReducer, on } from '@ngrx/store';

import * as UserActions from './user.actions';
import { initialState, UserState } from './user.state';

export const userReducer: ActionReducer<UserState, Action<string>> = createReducer(
  initialState,

  on(
    UserActions.loadUsers,
    (state): UserState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),

  on(
    UserActions.loadUsersSuccess,
    (state, { users }): UserState => ({
      ...state,
      users,
      loading: false,
      loaded: true,
    })
  ),

  on(
    UserActions.loadUsersFailure,
    (state, { error }): UserState => ({
      ...state,
      loading: false,
      error,
    })
  )
);

export const userFeature: ReturnType<typeof createFeature<string, UserState>> = createFeature({
  name: 'users',
  reducer: userReducer,
});
